import { useState, useEffect } from "react";
import "../../assets/scss/components/_stepper.scss";
import { Input } from "reactstrap";

interface StepperProps {
  onQuantityChange?: (quantity: number) => void;
  initialQuantity?: number;
  isEdit?: boolean;
}

const Stepper = ({
  onQuantityChange,
  initialQuantity = 0,
  isEdit = false,
}: StepperProps) => {
  const [value, setValue] = useState(initialQuantity);
  const [isAdded, setIsAdded] = useState(initialQuantity > 0);
  const [isValueEditing, setIsValueEditing] = useState<boolean>(false);

  // Sync with initialQuantity changes
  useEffect(() => {
    setValue(initialQuantity);
    setIsAdded(initialQuantity > 0);
  }, [initialQuantity]);

  const handleAdd = () => {
    setIsAdded(true);
    setValue(1);
    onQuantityChange?.(1);
  };

  const handleIncrement = () => {
    const newValue = value + 1;
    if (newValue > 1000) {
      return;
    }
    setValue(newValue);
    onQuantityChange?.(newValue);
  };

  const handleDecrement = () => {
    const newValue = Math.max(value - 1, 0);
    setValue(newValue);
    onQuantityChange?.(newValue);

    if (newValue === 0) {
      setIsAdded(false);
    }
  };

  if (!isAdded) {
    return (
      <button onClick={handleAdd} className="quantity-add-btn">
        Add
      </button>
    );
  }

  const handleValueChange = (e: any) => {
    const inputValue = e?.target?.value;

    // Only allow integer values (no decimals)
    if (inputValue.includes(".") || inputValue.includes(",")) {
      return;
    }

    const newValue = parseInt(inputValue, 10) || 0;
    if (newValue > 1000 || newValue < 0) {
      return;
    }
    setValue(newValue);
  };

  const finishEditing = () => {
    setIsValueEditing(false);
    onQuantityChange?.(value);
  };

  return (
    <div className="quantity-container">
      <i className="bx bx-minus quantity-icon" onClick={handleDecrement}></i>

      {isValueEditing ? (
        <Input
          value={value}
          className="quantity-value quantity-input"
          onChange={handleValueChange}
          onBlur={finishEditing}
          onKeyDown={(e) => {
            if (e.key === "Enter") e.currentTarget.blur();
            // Prevent decimal point and comma
            if (e.key === "." || e.key === ",") e.preventDefault();
          }}
          type="number"
          step="1"
        />
      ) : (
        <span
          className="quantity-value"
          onClick={() => setIsValueEditing(true)}
        >
          {value}
        </span>
      )}

      <i className="bx bx-plus quantity-icon" onClick={handleIncrement}></i>
    </div>
  );
};

export default Stepper;
